import { createContext, ReactNode, useMemo, useState } from 'react';

const noopFunc = () => new Error('Not implemented');

type ContextType = {
  highlightedCommentId: string | null;
  setHighlightedCommentId: (id: string | null) => void;
};

export const CommentHighlightContext = createContext<ContextType>({
  setHighlightedCommentId: noopFunc,
  highlightedCommentId: null,
});

export const CommentHighlightIdContext = createContext<string | null>(null);

export const SetCommentHighlightContext = createContext<(id: string | null) => void>(noopFunc);

export const CommentHighlightProvider = (props: { children: ReactNode }) => {
  const [highlightedCommentId, setHighlightedCommentId] = useState<string | null>(null);

  const contextValue = useMemo(
    () => ({
      highlightedCommentId,
      setHighlightedCommentId,
    }),
    [highlightedCommentId],
  );

  return (
    <CommentHighlightContext.Provider value={contextValue}>
      <SetCommentHighlightContext.Provider value={setHighlightedCommentId}>
        <CommentHighlightIdContext.Provider value={highlightedCommentId}>
          {props.children}
        </CommentHighlightIdContext.Provider>
      </SetCommentHighlightContext.Provider>
    </CommentHighlightContext.Provider>
  );
};
